export default "__VITE_ASSET__B2jUJgfl__"